import { IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about" className="bg-white text-[#1C1917] py-24 lg:py-36 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative aspect-[4/5] max-w-md">
              <img src={IMAGES.aboutPortrait} alt="Julia, lash artist" className="w-full h-full object-cover rounded-[2rem] shadow-soft" />
              <div className="absolute -bottom-6 -right-6 w-36 h-44 rounded-2xl overflow-hidden shadow-card border-4 border-white hidden sm:block">
                <img src={IMAGES.aboutSecondary} alt="Lash work" className="w-full h-full object-cover" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="w-10 h-px bg-[#C5B382]" />
              <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Meet Your Artist</span>
            </div>
            <h2 className="font-serif text-6xl sm:text-8xl font-medium leading-[0.9] tracking-tight">
              Julia<span className="text-[#C5B382]">.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-lg text-[#1C1917]/70 leading-relaxed max-w-xl">
              “Hi, I'm Julia — a certified Lash &amp; Brow Specialist based in Moonee Ponds, Melbourne.”
            </p>
            <p className="mt-4 text-lg text-[#1C1917]/70 leading-relaxed max-w-xl">
              I continuously invest in my education and refine my skills to deliver the highest
              standard of service — using up-to-date techniques and a personalised approach for
              every client.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base text-[#1C1917]/60 leading-relaxed max-w-xl">
              A certified Lash &amp; Brow Specialist working from a private studio in Moonee Ponds,
              Melbourne. Every appointment is one-on-one and unhurried — your set is tailored to
              your eye shape, natural lashes and the look you want, using premium products and
              up-to-date techniques for a result that's comfortable, long-lasting and made for you.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
